export interface RequestClaSignatureInput {
  projectSfid: string;
  claGroupId: string;
  companySfid: string;
  sendAsEmail: string;
  authorityName: string;
  authorityEmail: string;
  returnUrl: string;
}
